var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40002 5H2.60002V15.4H11.4V7.4H19C20.9882 7.4 22.6 9.01178 22.6 11V20H21.4V16.6H2.60002V20H1.40002V5ZM21.4 15.4V11C21.4 9.67452 20.3255 8.6 19 8.6H12.6V15.4H21.4ZM7.00002 9.6C6.22683 9.6 5.60002 10.2268 5.60002 11C5.60002 11.7732 6.22683 12.4 7.00002 12.4C7.77322 12.4 8.40002 11.7732 8.40002 11C8.40002 10.2268 7.77322 9.6 7.00002 9.6ZM4.40002 11C4.40002 9.56406 5.56408 8.4 7.00002 8.4C8.43596 8.4 9.60002 9.56406 9.60002 11C9.60002 12.4359 8.43596 13.6 7.00002 13.6C5.56408 13.6 4.40002 12.4359 4.40002 11Z"
  })));
};
export default SvgBed;